import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { PluginTemplate } from "types/generated";

const PluginTemplatesTableCreatedAtCell = ({
  item: plugin,
  ...cellProps
}: TableSimpleCellProps<PluginTemplate>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp timestamp={plugin.createdAt} />
    </TableSimpleCell>
  );
};

export default PluginTemplatesTableCreatedAtCell;
